import { baseClient } from '@/core/infrastructure/api/apiClient';
import { translate } from '@/core/utils/translate';

export enum channelentityEnum {
  ChannelType = 'ChannelType',
  LanguageType = 'LanguageType',
  Status = 'Status',
  PlatformType = 'PlatformType',
  VideoKind = 'VideoKind',
  Category = 'Category',
  PrivacyStatus = 'PrivacyStatus',
  ReportPeriod = 'ReportPeriod',
  MetricType = 'MetricType',
  ConnectionStatus = 'ConnectionStatus',
}
//Channel: getEnumKeyValueList
//"channel-service","organization-service","product-service"
export const getEnumKeyValueList = async (serviceType, enumType) => {
  try {
    const response = await baseClient.get(
      `/${serviceType}/commons/enums/${enumType}/key-value-list?Index=0&Size=10000`
    );

    const { header, body } = response.data as any;

    if (!header.isSuccess) {
      return header.message || translate('errors/api:fetch_enum_failed', { type: enumType });
    }

    return { header, body };
  } catch (error) {
    return error;
  }
};

//Channel: getEntityKeyValueList
export const getEntityKeyValueList = async ({ index, size, ids, entityType, serviceType }) => {
  try {
    const response = await baseClient.get(
      `${serviceType}/commons/entities/${entityType}/key-value-list`,
      {
        params: {
          Ids: ids,
          Index: index,
          Size: size,
          EntityType: entityType,
        },
      }
    );

    const { header, body } = response.data as any;

    if (!header.isSuccess) {
      return header.message || translate('errors/api:fetch_category_failed');
    }

    return { header, body };
  } catch (error) {
    return error;
  }
};

export enum OrganizationEnum {
  Company = 'company',
  Country = 'country',
  Department = 'department',
  Organization = 'organization',
  RoleGroup = 'rolegroup',
  Role = 'role',
  User = 'user',
}

export enum ChannelentityEnum {
  language = 'language',
  channel = 'channel',
  cms = 'cms',
}

export const allLanguage = async () => {
  try {
    const payload = {
      index: 0,
      size: 200,
    };

    const response = await baseClient.post('languages/search', payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

interface CategoryResponse {
  id: string;
  name: string;
  // Buraya API'den dönen diğer alanları da ekleyebilirsin.
}

export const allCategories = async (): Promise<CategoryResponse[]> => {
  try {
    const { data } = await baseClient.get<CategoryResponse[]>(
      'channel-service/commons/enums/Category/key-value-list',
      {
        params: { index: 0, size: 200 },
      }
    );
    return data;
  } catch (error) {
    void error;
    throw new Error(translate('errors/api:categories_load_failed'));
  }
};

export const allPlaylists = async ({
  limit,
  page,
  search = '',
  channleId,
  contractEndDate = '',
  contractStartDate = '',
  visibility,
}) => {
  try {
    const payload = {
      searchText: search,
      updateDateEnd: contractEndDate,
      updateDateStart: contractStartDate,
      privacyStatuses: visibility,
      pageNumber: page,
      pageSize: limit,
    };

    const response = await baseClient.post(`playlists/list/${channleId}`, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const uploadImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    // formData.append('CommandId', commandId);
    // formData.append('ApplyUnitofWork', applyUnitOfWork);

    const response = await baseClient.post('images/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    return error;
  }
};

export const allPolicies = async ({ limit, page, cmsId, search = '' }) => {
  try {
    const payload = {
      index: page,
      size: limit,
      cmsId,
      search,
    };

    const response = await baseClient.post(`/partners/policies`, payload);
    return response.data;
  } catch (error) {
    throw new Error(translate('errors/api:channel_info_fetch_failed'));
  }
};

export const allProducer = async ({ limit, page, search = '' }) => {
  try {
    const payload = {
      index: page,
      size: limit,
      search,
    };

    const response = await baseClient.post(`/producers/search`, payload);
    return response.data;
  } catch (error) {
    throw new Error(translate('errors/api:channel_info_fetch_failed'));
  }
};

export const getUserPermissions = async () => {
  try {
    const response = await baseClient.get('identity/roles/permissions', {
      headers: {
        accept: 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    void error;
    throw new Error(translate('errors/api:role_permissions_load_failed'));
  }
};
